import React, { ReactElement } from 'react'
import styled from 'styled-components'

import { SIZES, COLORS } from '~/common/globalStyles'
import Icon from '~/views/components/ui/Icon'

import { TooltipProps } from '@mui/material/Tooltip'
import Tooltip from '.'
import Icons from '../Icon/Icons'

const NarrowedTooltip = styled(Tooltip)(
  ({ theme }) => `
  .tooltip {
    padding: ${SIZES.xxs} ${SIZES.xs};
    line-height: ${theme.name === 'lightV2' ? theme.spacing(2) : '1.2'};
    white-space: pre-wrap;
  }
`,
)

interface HelpTooltipProps {
  title: string | ReactElement
  iconSize?: string
  iconColor?: keyof typeof COLORS
  iconStyles?: Record<string, any>
  toolTipWidth?: string
  iconName?: keyof typeof Icons
  tooltipPlacement?: TooltipProps['placement'] | string
}

const HelpTooltip: React.FC<HelpTooltipProps> = ({
  title,
  iconSize,
  iconColor,
  iconStyles,
  toolTipWidth,
  iconName = 'info',
  tooltipPlacement = 'top',
}) => {
  // Icon must be wrapped into a React.Element or JSX.Element
  // because now is a functional component and that seems to be
  // a problem for MUI
  const tooltipStyles = toolTipWidth
    ? { width: toolTipWidth }
    : { maxWidth: 300 }
  return (
    <NarrowedTooltip
      title={<div style={tooltipStyles}> {title}</div>}
      placement={tooltipPlacement}
      data-testid="tooltip-icon"
    >
      <span>
        <Icon
          name={iconName}
          height={iconSize ? iconSize : `${SIZES.medium}`}
          width={iconSize ? iconSize : `${SIZES.medium}`}
          style={iconStyles ? iconStyles : { marginLeft: SIZES.xxxs }}
          color={iconColor && iconColor}
        />
      </span>
    </NarrowedTooltip>
  )
}

export default HelpTooltip
